<template>

  <section class="bulk-issue-surface bulk-issue-surface--blocked">

    <div class="bulk-issue-surface__toolbar">

      <div class="bulk-issue-surface__meta">
         <strong>{{ items.length }}</strong
        > hóa đơn đang bị chặn trong lượt này
      </div>
       <b-form-select
        :value="filter"
        :options="filterOptions"
        size="sm"
        class="bulk-issue-surface__select"
        @input="$emit('filter-change', $event)"
      ></b-form-select
      >
    </div>
     <b-table
      :items="items"
      :fields="fields"
      small
      bordered
      responsive
      show-empty
      empty-text="Không có dữ liệu"
      class="bulk-issue-table"
      > <template #cell(invoiceNo)="{ item }"
        >
        <div class="bulk-issue-table__primary-cell">
           <strong>{{ item.invoiceNo }}</strong
          > <small>{{ item.salesInvoiceId }}</small
          >
        </div>
         </template
      > <template #cell(buyerName)="{ item }"
        > <span :class="{ 'bulk-issue-table__fallback': !item.buyerName }"
          > {{ item.buyerName || 'Không có thông tin' }} </span
        > </template
      > <template #cell(code)="{ item }"
        > <span class="bulk-issue-table__reason-pill">{{ getReasonLabel(item.code) }}</span
        > </template
      > <template #cell(message)="{ item }"
        >
        <div class="bulk-issue-table__message">
           {{ item.message || 'Không có mô tả chi tiết từ hệ thống.' }}
        </div>
         </template
      > </b-table
    >
  </section>

</template>

<script>
  import { getReasonLabel } from '../utils/bulkIssue.utils'

  export default {
    name: 'BulkIssueBlockedTable',
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      filter: {
        type: String,
        default: null,
      },
      filterOptions: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      fields() {
        return [
          { key: 'invoiceNo', label: 'Số HĐ' },
          { key: 'buyerName', label: 'Khách hàng' },
          { key: 'code', label: 'Lý do' },
          { key: 'message', label: 'Chi tiết' },
        ]
      },
    },
    methods: {
      getReasonLabel,
    },
  }
</script>

<style scoped>
  .bulk-issue-surface {
    border: 1px solid #e1e7ef;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
  }

  .bulk-issue-surface--blocked {
    border-color: #ebd9bf;
  }

  .bulk-issue-surface__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.85rem 1rem 0.65rem;
    border-bottom: 1px solid #edf1f6;
    background: #fffaf1;
  }

  .bulk-issue-surface__meta {
    color: #445166;
    font-size: 0.84rem;
  }

  .bulk-issue-surface__select {
    max-width: 220px;
  }

  .bulk-issue-table {
    margin-bottom: 0;
  }

  ::v-deep .bulk-issue-table table {
    margin-bottom: 0;
  }

  ::v-deep .bulk-issue-table thead th {
    background: #f9fafb;
    color: #445166;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .bulk-issue-table__primary-cell {
    display: flex;
    flex-direction: column;
    gap: 0.18rem;
  }

  .bulk-issue-table__primary-cell strong {
    color: #1f2a3d;
    font-size: 0.92rem;
    font-weight: 700;
  }

  .bulk-issue-table__primary-cell small {
    color: #7c8798;
    font-size: 0.72rem;
    word-break: break-all;
  }

  .bulk-issue-table__fallback {
    color: #8a94a5;
    font-style: italic;
  }

  .bulk-issue-table__reason-pill {
    display: inline-flex;
    align-items: center;
    padding: 0.26rem 0.58rem;
    border-radius: 999px;
    background: #fff1f2;
    color: #c94c5f;
    font-size: 0.74rem;
    font-weight: 700;
    line-height: 1.2;
  }

  .bulk-issue-table__message {
    max-width: 24rem;
    color: #556274;
    font-size: 0.8rem;
    line-height: 1.45;
  }

  @media (max-width: 767.98px) {
    .bulk-issue-surface__toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .bulk-issue-surface__select {
      max-width: none;
    }
  }
</style>

